import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";
import { Reveal, MaskedLines } from "./Reveal";
import { useContents } from "../hooks/useContents";
import { imgUrl } from "../lib/api";

export const CTABand = () => {
  const c = useContents();
  return (
  <section data-testid="cta-band" className="relative overflow-hidden">
    <img src={imgUrl(c("cta_img", "/images/cta.jpg"))} alt="" aria-hidden="true" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-base/88" aria-hidden="true" />
    <div className="absolute inset-x-0 top-0 h-px bg-steel" aria-hidden="true" />
    <div className="absolute inset-x-0 bottom-0 h-px bg-steel" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-10 py-24 lg:py-32">
      <p className="overline-label">Parliamone</p>
      <h2 className="h-display text-3xl sm:text-4xl lg:text-5xl mt-5 text-white max-w-3xl">
        <MaskedLines lines={c("cta_title", "Hai un progetto\nda realizzare?").split("\n")} />
      </h2>
      <Reveal delay={0.2}>
        <p className="mt-6 text-cement text-base sm:text-lg max-w-xl leading-relaxed">
          {c("cta_text", "Raccontaci cosa hai in mente. Valuteremo insieme la soluzione più adatta alle tue esigenze.")}
        </p>
      </Reveal>
      <Reveal delay={0.3}>
        <div className="mt-9 flex flex-col sm:flex-row gap-3">
          <Link to="/contatti" data-testid="cta-quote-button" className="btn-primary">
            Richiedi un preventivo <ArrowRight size={16} />
          </Link>
          <Link to="/contatti" data-testid="cta-call-button" className="btn-ghost">
            <Mail size={16} /> Contattaci
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
